module.exports = __webpack_public_path__ + "static/media/timer.19078c3a.svg";